import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { treatmentService } from '../../../services/treatments';

export const useSessionTreatmentConfig = () => {
  const [sessionTreatment, setSessionTreatment] = useState();
  const [treatmentData, setTreatmentData] = useState();

  const {
    sessions: { selectedSession },
  } = useSelector((state) => state);

  const { devicetreatmentconfigurationId, remotetreatmentconfigurationId } =
    selectedSession || {};

  const vrSession = !!(selectedSession && devicetreatmentconfigurationId);
  const remoteSession = !!(selectedSession && remotetreatmentconfigurationId);

  useEffect(() => {
    const getSessionTreatment = async (id, sessionType) => {
      switch (sessionType) {
        case 'remote':
          try {
            const { data: sessionTreatmentConfig } =
              await treatmentService.getRemoteTreatmentById(id);

            const {
              deviceId,
              therapistId,
              configurationdefinitionId,
              organizationId,
              received,
            } = sessionTreatmentConfig || {};
            setTreatmentData({
              deviceId,
              therapistId,
              configurationdefinitionId,
              organizationId,
              received,
            });
          } catch (error) {
            console.error('[Error]:', error);
          }
          break;
        case 'vr':
          try {
            const { data: sessionVRTreatmentConfig } =
              await treatmentService.getDeviceTreatmentConfigurationById(id);

            const {
              configurationdefinitionId,
              therapistId,
              organizationId,
              deviceId,
              templateId,
              treatmentconfigurationId,
              starts_at,
            } = sessionVRTreatmentConfig || {};
            setTreatmentData({
              configurationdefinitionId,
              therapistId,
              organizationId,
              deviceId,
              templateId,
              treatmentconfigurationId,
              starts_at,
            });
          } catch (error) {
            console.error('[Error]:', error);
          }
          break;
      }
    };

    if (remoteSession)
      getSessionTreatment(remotetreatmentconfigurationId, 'remote');
    else if (vrSession)
      getSessionTreatment(devicetreatmentconfigurationId, 'vr');
  }, [
    devicetreatmentconfigurationId,
    remoteSession,
    remotetreatmentconfigurationId,
    selectedSession,
    vrSession,
  ]);

  return { treatmentData, remoteSession, vrSession };
};
